(async () => {

  if (!customElements.get('product-description-usps')) {

    const { Fancybox } = await import("@fancyapps/ui");
    class ProductDescriptionUsps extends HTMLElement {
      
      constructor() {
        super();
        this.popupButtons = this.querySelectorAll('[data-fancybox-trigger]');
        this.popupButtons.forEach((button) => {
          button.addEventListener('click', this.openPopup.bind(this));
        });
      }

      /*
        * Create fancybox
      */
      openPopup(trigger) {

        // Check if Fancybox exists
        if (typeof Fancybox == 'undefined') {
          return false;
        }
        let content = trigger.target.closest('[data-fancybox-trigger]').querySelector('[data-fancybox-content]').innerHTML;
        new Fancybox([
          {
            src: content,
            type: 'html',
          },
        ]);
      }

    }

    window.ProductDescriptionUsps = ProductDescriptionUsps;

    customElements.define('product-description-usps', ProductDescriptionUsps);
  }
})();
